import React, { useRef } from "react";

import NoData from "../../../../../Dashboard/Charts/NoData/NoData";

import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import "./CompetitorRecentPosts.scss";
import CustomDropdown from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/CustomDropdown";
import Loading from "../../../InstagramInsights/components/Loading/Loading";
// import CompPageSelector from "./CompPageSelector";
import RecentPostWrapper from "./RecentPostWrapper";
import { toTitleCase } from "../../../../../Dashboard/Charts/utils";

function CompetitorRecentPosts(props) {
    // const carouselRef = useRef(null);

    let filteredData = props.data;

    let competitorAccountList = props.competitorList;

    if (props.isCompPage) {
        if (props.selectedCompetitors.length > 0) {
            competitorAccountList = competitorAccountList.filter((ac) => props.selectedCompetitors.includes(ac.research_query_id));
        }
    }
    const chartEl = useRef();

    let nodata = Object.entries(filteredData).length === 0 && !props.loading;

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName name={props.widget?.name || "Recent Posts"} info="This section shows posts based on the sorting options selected." />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isCompPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget?.name}
                            />
                        )}

                    <MoreOptions data-html2canvas-ignore="true" className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!nodata && (
                        <>
                            <CustomDropdown
                                className="interval-selector"
                                name="Sort By"
                                options={props.postOrderByList}
                                value={props.postOrderBy}
                                onChange={props.changePostOrderBy}
                            />
                        </>
                    )}
                    {!props.isCompPage &&
                        !props.isPublic &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings />
                                </div>
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                            </>
                        )}
                    {!props.isCompPage &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        !props.isPublic &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && <DeleteWidget onClick={props.deleteWidget} />}
                </ChartOptionsSidebar>
            )}

            <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={chartEl}>
                <div className="chart-area">
                    {!nodata ? (
                        <div className="recentPosts competitor__insights__posts">
                            {props.selectedCompetitors && !props.loading && (
                                <div className="competitor__heading__container">
                                    {props.selectedCompetitors.map((pageId, index) => (
                                        // <div key={pageId}>
                                        // <span className="competitor__heading" key={pageId}>
                                        //     {`${filteredData?.[pageId]?.userName ? toTitleCase(filteredData?.[pageId]?.userName) : null} `}
                                        // </span>
                                        // <span>({filteredData?.[pageId]?.platform})</span>
                                        // </div>
                                        <p className="competitor__heading" key={pageId}>
                                            {`${filteredData?.[pageId]?.userName ? toTitleCase(filteredData?.[pageId]?.userName || "") : null} (${toTitleCase(
                                                filteredData?.[pageId]?.platform || "",
                                            )})`}
                                        </p>
                                    ))}
                                </div>
                            )}

                            {props.selectedCompetitors && !props.loading ? (
                                <>
                                    {props.selectedCompetitors.map((pageId, index) => (
                                        <>
                                            <RecentPostWrapper key={pageId} pageId={pageId} filteredData={filteredData?.[pageId]} />
                                        </>
                                    ))}
                                </>
                            ) : (
                                <Loading />
                            )}
                        </div>
                    ) : (
                        <NoData />
                    )}
                </div>
            </div>
        </>
    );

    return props.isCompPage ? <div className={`dashboard-widget-container ${props.expandWidget ? "maximize-widget" : ""}`}>{elements}</div> : <>{elements}</>;
}

export default CompetitorRecentPosts;
